<section class="home-banner spacing-header">

  <section>
    <div class="finalise-quote padding-bottom-xxbig bg-surface-highlight">

      <div class="grid grid-wrapper align-middle text-center-medium-down align-center-medium-down padding-top-medium">
        <div class="cell cell-large-col-span-6 cell-medium-col-span-8">
          <div class="display-large text-surface-decorative padding-top-xxbig margin-top-xxbig"><span>Finalise your<br></span><span>quote</span></div>
          <div class="text-large text-blackMatte margin-vertical-medium">You'll need to confirm the answers you've previously given and answer any extra questions so we know the details that we're using are correct</div>
          <button mat-flat-button color="primary" type="button" [routerLink]="['/quote/' + reference?.uuid]">Continue quote</button>
        </div>

        <div class="cell cell-large-col-span-6 cell-medium-col-span-8">
          <div product="home">
            <div class="block-price-details bg-surface-section shadow margin-top-xlarge">
              <div class="padding-medium">
                <h1 class="text-blackMatte margin-vertical-small"> </h1>
                <div>
                  <div class="margin-vertical-small">
                    <div class="flex align-middle margin-bottom-medium">
                      <div class="flex-grow text-left">
                        <h2 class="text-blackMatte margin-none">{{ quote?.human.cover_level }}</h2>
                      </div>
                      <div class="flex-shrink text-right"><img src="/assets/partners/huddle/svgs/huddle-filled-car-yourcar.svg" height="72" width="72" alt="car logo" class="svg icon"></div>
                    </div>
                    <div class="flex margin-bottom-xxsmall">
                      <div class="flex-shrink">
                        <h4 class="text-blackMatte margin-none">Quote number</h4>
                      </div>
                      <div class="flex-grow">
                        <p class="text-right text-darkGray margin-none">{{ reference?.quote_number }}</p>
                      </div>
                    </div>
                    <div class="flex margin-bottom-xxsmall">
                      <div class="flex-shrink">
                        <h4 class="text-blackMatte margin-none">Year</h4>
                      </div>
                      <div class="flex-grow">
                        <p class="text-right text-darkGray margin-none">{{ quote?.human.vehicle.year }}</p>
                      </div>
                    </div>
                    <div class="flex margin-bottom-xxsmall">
                      <div class="flex-shrink">
                        <h4 class="text-blackMatte margin-none">Engine</h4>
                      </div>
                      <div class="flex-grow">
                        <p class="text-right text-darkGray margin-none">{{ vehicle }}</p>
                      </div>
                    </div>
                    <div class="flex margin-bottom-xxsmall">
                      <div class="flex-shrink">
                        <h4 class="text-blackMatte margin-none">Cover Type</h4>
                      </div>
                      <div class="flex-grow">
                        <p class="text-right text-darkGray margin-none">{{ quote?.human.cover_type }}</p>
                      </div>
                    </div>
                    <div class="flex margin-bottom-xxsmall">
                      <div class="flex-shrink">
                        <h4 class="text-blackMatte margin-none">Start date</h4>
                      </div>
                      <div class="flex-grow">
                        <p class="text-right text-darkGray margin-none">{{ quote?.human.start_date }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="block-price-details padding-small bg-surface-decorative text-white text-left margin-bottom-small">
                <p class="strong text-surface-decorative-text margin-bottom-xxsmall" *ngIf="arrangementFeeBanner && quote.data.frequency === 'M'" [innerHTML]="arrangementFeeBanner.monthlyHeading"></p>
                <div class="row align-middle">
                  <div class="small-12 columns">
                    <div class="flex-container align-middle margin-bottom-xxsmall">
                      <open-price [price]="price" [precision]="precision"></open-price>
                    </div>
                  </div>
                </div>
                <p class="strong text-surface-decorative-text margin-bottom-xxsmall" *ngIf="arrangementFeeBanner" [innerHTML]="quote.data.frequency === 'M' ? arrangementFeeBanner.tag.monthly : arrangementFeeBanner.tag.annual"></p>
              </div>
            </div>
            <div
              id="trustbox-rating-2"
              class="trustpilot-widget margin-bottom-medium"
              data-locale="en-GB"
              data-style-height="40px"
              data-style-width="100%"
              data-theme="light"
              data-stars="3,4,5"
              data-tags="SelectedReview"
              data-schema-type="Organization">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <a id="product-information"></a>

  <div class="component-product-information">
    <div class="component-product-features">
      <section>
        <div class="grid grid-wrapper padding-top-xbig">
          <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-bottom-xxbig">
            <img class="svg icon" height="72" width="72" src="/assets/svgs/illustrations/huddle/huddle-housing-marketing-optionals.svg">
            <h2 class="text-blackMatte margin-vertical-small">Insurance made easy</h2>
            <p class="text-darkGray margin-none ">Buy, manage and make claims online – you're in control. It's how insurance should be.</p>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-bottom-xxbig">
            <img class="svg icon" height="72" width="72" src="/assets/svgs/illustrations/huddle/huddle-housing-valuables-electronics.svg">
            <h2 class="text-blackMatte margin-vertical-small">Back on your feet, faster</h2>
            <p class="text-darkGray margin-none ">Submit a claim online 24/7. Our clever tech and expert claims team will get the ball rolling so you get the help you need.</p>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-bottom-xxbig">
            <img class="svg icon" height="72" width="72" src="/assets/svgs/illustrations/huddle/huddle-housing-marketing-localsupport.svg">
            <h2 class="text-blackMatte margin-vertical-small">Local insurance experts</h2>
            <p class="text-darkGray margin-none ">Have questions about your quote, policy or claim? Our friendly Sunshine Coast and Melbourne teams can give you a hand.</p>
          </div>
        </div>
      </section>
    </div>

    <section>
      <div class="grid grid-wrapper padding-vertical-xbig">
        <div class="cell cell-large-col-span-6 cell-medium-col-span-4 cell-small-col-span-8 flex flex-row flex-items-center">
          <div>
            <h1 class="text-surface-decorative padding-vertical-small">Smart savings with<br>Pay As You Drive</h1>
            <p class="text-blackMatte">Save up to 30% on your premium if you drive 15,000km or less each year compared to our regular Comprehensive Cover.**</p>
            <p class="text-blackMatte margin-bottom-medium">Just pay for the distance you need and pocket the savings.</p>
          </div>
        </div>
        <div class="cell cell-large-col-span-6 cell-medium-col-span-4 cell-small-col-span-8 text-center">
          <lottie-player src="/assets/animations/payd.json" background="transparent" autoplay loop></lottie-player>
          <p class="text-darkGray margin-bottom-medium">Example savings shown. Specific savings dependent on individual application.</p>
        </div>
      </div>
    </section>

    <section class="bg-surface-highlight">
      <div class="grid grid-wrapper padding-top-xxbig">
        <div class="cell cell-large-col-span-12 text-center">
          <div class="display-small text-surface-decorative margin-top-none margin-bottom-medium">Comprehensive cover stacked with benefits</div>
          <p class="text-blackMatte margin-bottom-xlarge margin-top-none"><span>These benefits come with your policy. Looking for Third Party Property Cover?&nbsp;</span><span><a (click)="showComparison()" class="action-tertiary-link">Compare our covers</a></span><span>.</span></p>
        </div>
      </div>

      <div class="grid grid-wrapper align-center">
        <div class="cell cell-large-col-span-12 mobile-horizontal-padding">
          <div class="grid">
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-options-fire_theft.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">Theft and damage cover</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We&apos;ve got you covered for loss or damage caused by collision, fire, malicious damage, theft, attempted theft and natural events like hail, storm, flood and bushfire.</p>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-marketing-childsafetyseats.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">Child safety seats and prams</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We&apos;ll pay up to $500 to help cover the cost of replacing child seats, baby capsules and prams damaged or stolen in an incident involving your car.</p>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-marketing-newforold.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">New for old car replacement</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We&apos;ll replace your car with a new one if it&apos;s under 2 years old and it&apos;s written off and you&apos;re the first registered owner.</p>
              <div class="black-capsule-container">
                <span class="text-capsule bg-featured medium"><span class="strong-small text-white">Up to 3 years with&nbsp;</span><span class="strong-small text-white">Huddle Black</span></span>
              </div>
              <p class="text-small text-darkGray margin-top-xsmall">If car is driven less than 70,000km.</p>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-valuables-electronics.svg" width="40" height="40" class="svg icon small flex-grow">
              <h4 class="text-blackMatte margin-vertical-small">Personal property cover</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We&apos;ll pay up to $500 for theft or damage to personal property in the car, that is designed to be worn or carried, such as clothes or bags.</p>
              <div class="black-capsule-container">
                <span class="text-capsule bg-featured medium"><span class="strong-small text-white">Up to $1,000 with&nbsp;</span><span class="strong-small text-white">Huddle Black</span></span>
              </div>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-marketing-emergencyaccommodation.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">Emergency travel and accommodation</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We&apos;ll pay up to $500 for your necessary travel and accommodation if your car is damaged by a covered incident, can&apos;t be safely driven and is over 200km from home.</p>
              <div class="black-capsule-container">
                <span class="text-capsule bg-featured medium"><span class="strong-small text-white">Up to $2,000 with&nbsp;</span><span class="strong-small text-white">Huddle Black</span></span>
              </div>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-options-hirecar.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">Hire car after theft</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">If your car is stolen, we&apos;ll either organise the hire of a car or reimburse you the cost of a hire car to get you back on the road, up to $70 a day for 14 days.</p>
              <div class="black-capsule-container">
                <span class="text-capsule bg-featured medium"><span class="strong-small text-white">Up to $80/day with&nbsp;</span><span class="strong-small text-white">Huddle Black</span></span>
              </div>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-stuff-key.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">Lock and key replacement</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">If your keys are stolen, we will pay up to $1,000 to replace or recode your car&apos;s locks and keys.</p>
              <div class="black-capsule-container">
                <span class="text-capsule bg-featured medium"><span class="strong-small text-white">Up to $2,000 with&nbsp;</span><span class="strong-small text-white">Huddle Black</span></span>
              </div>
            </div>
            <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-12 margin-bottom-xlarge flex flex-column">
              <img src="/assets/svgs/illustrations/huddle/huddle-outlined-marketing-liablity.svg" width="40" height="40" class="svg icon small">
              <h4 class="text-blackMatte margin-vertical-small">Up to $20m liability cover</h4>
              <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">You&apos;re covered for damage to someone else&apos;s vehicle or property, caused by the use of your car, up to $20 million.</p>
              <div class="black-capsule-container">
                <span class="text-capsule bg-featured medium"><span class="strong-small text-white">Up to $30m with&nbsp;</span><span class="strong-small text-white">Huddle Black</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-wrapper padding-bottom-xxbig">
        <div class="cell cell-large-col-span-12">
          <div class="text-small text-darkGray margin-right-small">
            <span>Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant  <a href="https://huddle.com.au/pds" class="action-tertiary-link">Product Disclosure Statement (PDS)</a> and the <a href="https://huddle.com.au/pds" class="action-tertiary-link">Target Market Determination (TMD)</a> which explains who the products are suitable for.</span>
          </div>
        </div>
      </div>
    </section>




    <section class="section-cover-types">
      <div class="extras-info padding-vertical-xxbig">
        <div class="grid grid-wrapper">
          <div class="cell cell-large-col-span-12 text-center">
            <div class="display-small text-surface-decorative margin-top-none margin-bottom-medium">Choose your extras</div>
            <p class="text-blackMatte margin-bottom-xlarge">Customise your Comprehensive Cover with the add-ons that suit you.</p>
          </div>
        </div>
        <div class="grid margin-bottom-small flex-container flex-dir-column">
          <div class="cell cell-large-col-span-4 flex-child-grow flex-container flex-dir-column open-section bg-white">
            <div>
              <img src="/assets/svgs/illustrations/huddle/huddle-housing-options-hirecar.svg" class="extra-icon">
              <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Hire car</h4>
              <p class="text-small text-darkGray margin-none">Cover for the cost of a hire car if we accept a claim for theft or attempted theft damage, up to $70 a day for 10 days.</p>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 flex-child-grow flex-container flex-dir-column open-section bg-white">
            <div>
              <img src="/assets/svgs/illustrations/huddle/huddle-housing-options-excessfreewindscreen.svg" class="extra-icon">
              <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Excess-free windscreen</h4>
              <p class="text-small text-darkGray margin-none">We'll repair or replace your front windscreen excess-free, once every 12 months.</p>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 flex-child-grow flex-container flex-dir-column open-section bg-white">
            <div>
              <img src="/assets/svgs/illustrations/huddle/huddle-housing-options-sportcover.svg" class="extra-icon">
              <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Sports gear cover</h4>
              <p class="text-small text-darkGray margin-none">Up to $3,000 to cover your sports gear while it's in or on your car. Cover terms apply.</p>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 flex-child-grow flex-container flex-dir-column open-section bg-white">
            <div>
              <img src="/assets/svgs/illustrations/huddle/huddle-housing-options-kangacover.svg" class="extra-icon">
              <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Kanga Cover</h4>
              <p class="text-small text-darkGray margin-none">Your first animal collision claim within a 12 month period is excess-free.</p>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 flex-child-grow flex-container flex-dir-column open-section bg-white">
            <div>
              <img src="/assets/svgs/illustrations/huddle/huddle-housing-options-roadassistance.svg" class="extra-icon">
              <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Roadside assistance</h4>
              <p class="text-small text-darkGray margin-none">Essential roadside assistance to help get you back on the road. This is a separate service provided by Allianz Global Assistance. Also available with Third Party Property Cover.<br><a href="https://huddle.com.au/pds" class="action-tertiary-link">Read the Roadside Assistance T&amp;Cs</a>.</p>
            </div>
          </div>
        </div>
        <div class="grid margin-top-medium">
          <div class="cell cell-large-col-span-12">
            <div class="text-small spacing-right-small text-medium text-darkGray">
              <span>Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant </span>
              <span>&nbsp;<a href="https://huddle.com.au/pds" class="action-tertiary-link">Product Disclosure Statement (PDS)</a> and the <a href="https://huddle.com.au/pds" class="action-tertiary-link">Target Market Determination (TMD)</a> which explains who the products are suitable for.</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="grid grid-wrapper padding-vertical-xxbig">
        <div product="home" class="cell cell-large-col-span-12">

          <div class="component-huddle-black-intro block large padding-large bg-featured">
            <div class="align-middle compact-intro slide-up">
              <div class="grid">
                <div class="cell cell-large-col-span-12">
                  <div class="display-small text-white margin-bottom-xxsmall">Huddle Black</div>
                  <p class="text-white margin-bottom-large margin-top-small">Our premium cover means exclusive benefits and greater peace of mind. We even help cover your rental car excess.</p>
                </div>
              </div>
              <div class="small-12 large-order-1 columns">
                <div>
                  <div class="grid">
                    <div class="cell cell-large-col-span-6 cell-small-col-span-6">
                      <div class="flex margin-bottom-small">
                        <div class="flex-shrink margin-right-small"><img src="/assets/svgs/illustrations/huddle/huddle-outlined-marketing-highestlimits.svg" height="40" width="40" class="svg icon small"></div>
                        <div>
                          <h4 class="margin-top-none margin-bottom-xsmall text-white">Boost your protection</h4>
                          <p class="text-small text-white">Get higher cover for personal property, emergency accommodation and travel, locks, keys, plus more.</p>
                        </div>
                      </div>
                    </div>
                    <div class="cell cell-large-col-span-6 cell-small-col-span-6">
                      <div class="flex margin-bottom-small">
                        <div class="flex-shrink margin-right-small"><img src="/assets/svgs/illustrations/huddle/huddle-outlined-marketing-newforold-white.svg" height="40" width="40" class="svg icon small"></div>
                        <div>
                          <h4 class="margin-top-none margin-bottom-xsmall text-white">3 years new for old car replacement</h4>
                          <p class="text-small text-white">Get a bonus year of new for old protection for your new car, if it's travelled up to 70,000kms.</p>
                        </div>
                      </div>
                    </div>
                    <div class="cell cell-large-col-span-6 cell-small-col-span-6">
                      <div class="flex margin-bottom-small">
                        <div class="flex-shrink margin-right-small"><img src="/assets/svgs/illustrations/huddle/huddle-outlined-country-australia.svg" height="40" width="40" class="svg icon small"></div>
                        <div>
                          <h4 class="margin-top margin-bottom-xsmall-none text-white">Rental car excess covered anywhere in Australia</h4>
                          <p class="text-small text-white">Grabbing a rental car for your holiday? We'll cover up to $2,000 for the excess charged if the rental car is damaged or stolen. Cover terms apply.</p>
                        </div>
                      </div>
                    </div>
                    <div class="cell cell-large-col-span-6 cell-small-col-span-6">
                      <div class="flex margin-bottom-small">
                        <div class="flex-shrink margin-right-small"><img src="/assets/svgs/illustrations/huddle/huddle-outlined-options-chooserepairer.svg" height="40" width="40" class="svg icon small"></div>
                        <div>
                          <h4 class="margin-top-none margin-bottom-xsmall text-white">Choose your repairer</h4>
                          <p class="text-small text-white">You can choose your own repairer or a trusted repairer we choose of dedicated partners across Australia.</p>
                        </div>
                      </div>
                    </div>
                    <div class="cell cell-large-col-span-6 cell-small-col-span-6">
                      <div class="flex margin-bottom-small">
                        <div class="flex-shrink margin-right-small"><img src="/assets/svgs/illustrations/huddle/huddle-outlined-options-roadassistance.svg" height="40" width="40" class="svg icon small"></div>
                        <div>
                          <h4 class="margin-top-none text-white">24/7 Roadside Assistance</h4>
                          <p class="text-small text-white">Enjoy peace of mind with a trusted national support network in Australia and unlimited callouts.<sup>†</sup></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid">
              <div class="cell cell-large-col-span-12">
                <button mat-flat-button color="primary" type="button" [routerLink]="['/quote/' + reference?.uuid]" class="margin-bottom-large">Continue quote</button>
                <div class="text-small text-white">Huddle Black benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a href="https://huddle.com.au/pds" class="text-white" target="_blank">Product Disclosure Statement (PDS)</a> and the <a href="https://huddle.com.au/pds" class="text-white" target="_blank">Target Market Determination (TMD)</a> which explains who the products are suitable for.</div>
                <div class="text-small text-white margin-top-small">† Service area limitations, other limitations, exclusions and terms and conditions apply.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-reviews bg-surface-highlight">
      <div class="padding-vertical-xxbig grid grid-wrapper">
        <div class="cell cell-large-col-span-12 display-small text-surface-decorative text-center margin-top-none margin-bottom-medium">Trusted by thousands of Australians</div>
        <div content-list="productInformationCtrl.data.reviews.home" class="component-review-scroller cell cell-large-col-span-12">

          <div class="review-scroller">
            <div class="grid">
              <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-3 cell-tiny-col-span-4">
                <div class="block open-section bg-white height-full padding-medium trustpilot-card">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <h4 class="text-blackMatte margin-bottom-small margin-top-xsmall">Hassle free at my speed</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small ">Can't believe the efficiency and quality service. The whole process was simple, straightforward and the best bit - nobody hassling me. Hopefully, I'll never have to use your services, but if I do, I feel quite confident that I will be supported at a stressful time.</p>
                  <div class="strong-small text-blackMatte ">Warren</div>
                </div>
              </div>
              <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-3 cell-tiny-col-span-4">
                <div class="block open-section bg-white height-full padding-medium trustpilot-card">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <h4 class="text-blackMatte margin-bottom-small margin-top-xsmall">I have been with Huddle for 3 years</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small ">I Have been with Huddle for 3 consecutive years. I have my Car, Home and Content all insured from Huddle. Claims were super easy and hassle free and the customer support is amazing. I don't drive much so the limited kilometres offer from Huddle is a big saver for me.</p>
                  <div class="strong-small text-blackMatte ">Anish</div>
                </div>
              </div>
              <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-3 cell-tiny-col-span-4">
                <div class="block open-section bg-white height-full padding-medium trustpilot-card">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <h4 class="text-blackMatte margin-bottom-small margin-top-xsmall">Amazing price and ease of service!</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small ">Amazing price and ease of service! Had an issue where the incorrect Model Year was selected for my car and a simple phone call resolved it quickly. Very happy with the help and service.</p>
                  <div class="strong-small text-blackMatte ">Scott</div>
                </div>
              </div>
              <div class="cell cell-large-col-span-3 cell-medium-col-span-4 cell-small-col-span-3 cell-tiny-col-span-4">
                <div class="block open-section bg-white height-full padding-medium trustpilot-card">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <img src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
                  <h4 class="text-blackMatte margin-bottom-small margin-top-xsmall">Cheap and best car insurance</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small ">Ideal for those who don’t drive much as this is a “pay as you go” insurance. Lesser the kms/year lesser the premium. Very easy and convenient, highly recommended.</p>
                  <div class="strong-small text-blackMatte ">Dp Rai</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <a id="feature-claim-process"></a>

    <section class="section-claims">
      <div product="home" is-partner-quote="productInformationCtrl.isPartnerQuote" class="component-feature-claim-process">
        <section class="feature-claim-process">
          <div class="grid grid-wrapper align-middle padding-vertical-xxbig">
            <div class="section-claims-hero cell cell-large-col-span-6 cell-medium-col-span-3 cell-small-col-span-6">
              <img ng-src="/assets/images/home/home-get-local-help.png" alt="Get local help for claims" src="/assets/images/huddle/car-get-local-help.png">
            </div>
            <div class="cell cell-large-col-span-5 cell-medium-col-span-5 cell-small-col-span-6 flex flex-row flex-items-center">
              <div>
                <div class="display-small text-surface-decorative margin-bottom-medium">Make claims in a flash,<br>get local help</div>
                <p class="text-blackMatte">Submit a claim online anytime. In some cases you'll get a decision in minutes.</p>
                <p class="text-blackMatte margin-bottom-medium">Our Aussie-based experts are here to help you get back on the road.</p>
                <a href="https://huddle.com.au/claims" target="_blank" mat-button color="primary">Get more info on how our claims work<mat-icon class="right chevron_right"></mat-icon></a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</section>

<section>
  <div class="finalise-quote padding-bottom-xxbig bg-surface-highlight">

    <div class="grid grid-wrapper align-middle text-center-medium-down align-center-medium-down padding-top-medium">
      <div class="cell cell-large-col-span-6 cell-medium-col-span-8">
        <div class="display-large text-surface-decorative padding-top-xxbig margin-top-xxbig"><span>Finalise your<br></span><span>quote</span></div>
        <div class="text-large text-blackMatte margin-vertical-medium">You'll need to confirm the answers you've previously given and answer any extra questions so we know the details that we're using are correct</div>
        <button mat-flat-button color="primary" type="button" [routerLink]="['/quote/' + reference?.uuid]">Continue quote</button>
      </div>

      <div class="cell cell-large-col-span-6 cell-medium-col-span-8">
        <div product="home">
          <div class="block-price-details bg-surface-section shadow margin-top-xlarge">
            <div class="padding-medium">
              <h1 class="text-blackMatte margin-vertical-small"> </h1>
              <div>
                <div class="margin-vertical-small">
                  <div class="flex align-middle margin-bottom-medium">
                    <div class="flex-grow text-left">
                      <h2 class="text-blackMatte margin-none">{{ quote?.human.cover_level }}</h2>
                    </div>
                    <div class="flex-shrink text-right"><img src="/assets/partners/huddle/svgs/huddle-filled-car-yourcar.svg" height="72" width="72" alt="car logo" class="svg icon"></div>
                  </div>
                  <div class="flex margin-bottom-xxsmall">
                    <div class="flex-shrink">
                      <h4 class="text-blackMatte margin-none">Quote number</h4>
                    </div>
                    <div class="flex-grow">
                      <p class="text-right text-darkGray margin-none">{{ reference?.quote_number }}</p>
                    </div>
                  </div>
                  <div class="flex margin-bottom-xxsmall">
                    <div class="flex-shrink">
                      <h4 class="text-blackMatte margin-none">Year</h4>
                    </div>
                    <div class="flex-grow">
                      <p class="text-right text-darkGray margin-none">{{ quote?.human.vehicle.year }}</p>
                    </div>
                  </div>
                  <div class="flex margin-bottom-xxsmall">
                    <div class="flex-shrink">
                      <h4 class="text-blackMatte margin-none">Engine</h4>
                    </div>
                    <div class="flex-grow">
                      <p class="text-right text-darkGray margin-none">{{ vehicle }}</p>
                    </div>
                  </div>
                  <div class="flex margin-bottom-xxsmall">
                    <div class="flex-shrink">
                      <h4 class="text-blackMatte margin-none">Cover Type</h4>
                    </div>
                    <div class="flex-grow">
                      <p class="text-right text-darkGray margin-none">{{ quote?.human.cover_type }}</p>
                    </div>
                  </div>
                  <div class="flex margin-bottom-xxsmall">
                    <div class="flex-shrink">
                      <h4 class="text-blackMatte margin-none">Start date</h4>
                    </div>
                    <div class="flex-grow">
                      <p class="text-right text-darkGray margin-none">{{ quote?.human.start_date }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="block-price-details padding-small bg-surface-decorative text-white text-left margin-bottom-small">
              <p class="strong text-surface-decorative-text margin-bottom-xxsmall" *ngIf="arrangementFeeBanner && quote.data.frequency === 'M'" [innerHTML]="arrangementFeeBanner.monthlyHeading"></p>
              <div class="row align-middle">
                <div class="small-12 columns">
                  <div class="flex-container align-middle margin-bottom-xxsmall">
                    <open-price [price]="price" [precision]="precision"></open-price>
                  </div>
                </div>
              </div>
              <p class="strong text-surface-decorative-text margin-bottom-xxsmall" *ngIf="arrangementFeeBanner" [innerHTML]="quote.data.frequency === 'M' ? arrangementFeeBanner.tag.monthly : arrangementFeeBanner.tag.annual"></p>
            </div>
          </div>
          <div
            id="trustbox-rating-2"
            class="trustpilot-widget margin-bottom-medium"
            data-locale="en-GB"
            data-style-height="40px"
            data-style-width="100%"
            data-theme="light"
            data-stars="3,4,5"
            data-tags="SelectedReview"
            data-schema-type="Organization">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="margin-none padding-vertical-xxbig">
  <div class="grid grid-wrapper">
    <!-- Additional Charges Disclaimers -->
    <div class="cell cell-large-col-span-12" *ngIf="quote.covers[0].has_additional_charges">
      <div class="text-small text-darkGray">
        <p *ngIf="quote.covers[0].additional_fees_disclaimer">* {{ quote.covers[0].additional_fees_disclaimer }}</p>
        <ul *ngIf="additionalChargesDisclaimers.length">
          <li *ngFor="let additionalCharges of additionalChargesDisclaimers"><strong>{{ additionalCharges.label }}:</strong> {{ additionalCharges.disclaimer }}</li>
        </ul>
      </div>
    </div>

    <!-- PAYD Discount Disclaimer -->
    <div class="cell cell-large-col-span-12">
      <div class="strong-small text-darkGray margin-bottom-xsmall">How our Pay As You Drive discount works</div>
      <div class="text-small text-darkGray">** If you drive less than 15,000 km a year, Huddle's Pay As You Drive Cover could save you up to 30% compared to our regular Comprehensive Cover.</div>
    </div>
  </div>
</section>

